import { isCurveVertex } from '@i-ark/models';
import { setBorder } from './setBorder.js';

const drawLegacyCanvasShape = ({
  ctx,
  canvasSize,
  strokeWidth = 0.5,
  item
}) => {
  // In case of an empty string, then we should fallback to a white color. If
  // we don't do this, then the fill will fallback to the strokeStyle instead
  // which ins't the desired result
  ctx.fillStyle = item.style.background.color || "transparent";
  ctx.strokeStyle = item.style.stroke.color;
  setBorder(ctx, item.style.stroke.type, strokeWidth);
  switch (item.type) {
    case "polygon":
      drawLegacyCanvasPolygon(ctx, item, canvasSize);
      break;
    case "circle":
      drawLegacyCanvasCircle(ctx, item, canvasSize);
      break;
    case "rectangle":
      drawLegacyCanvasRectangle(ctx, item, canvasSize);
      break;
  }
};
function drawLegacyCanvasRectangle(ctx, item, canvasSize) {
  ctx.beginPath();
  ctx.rect(item.position.x * canvasSize.width, item.position.y * canvasSize.height, item.size.width * canvasSize.width, item.size.height * canvasSize.height);
  ctx.globalAlpha = item.style.background.opacity;
  ctx.fill();
  ctx.globalAlpha = 1;
  ctx.stroke();
}
function drawLegacyCanvasCircle(ctx, item, canvasSize) {
  ctx.beginPath();
  ctx.ellipse((item.position.x + item.radius) * canvasSize.width, item.position.y * canvasSize.height + item.radius * canvasSize.width, item.radius * canvasSize.width, item.radius * canvasSize.width, 0, 0, 2 * Math.PI);
  ctx.globalAlpha = item.style.background.opacity;
  ctx.fill();
  ctx.globalAlpha = 1;
  ctx.stroke();
}
function drawLegacyCanvasPolygon(ctx, item, canvasSize) {
  const firstVertex = item.vertices[0];
  if (firstVertex === undefined) {
    return;
  }
  ctx.beginPath();
  ctx.moveTo(...getNormalizedCoordinate(firstVertex.coordinate, item, canvasSize));
  for (let i = 1; i < item.vertices.length; i++) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    drawVertex(ctx, item.vertices[Number(i)], item, canvasSize);
  }
  const endVertex = item.vertices[0];
  if (endVertex) {
    drawVertex(ctx, endVertex, item, canvasSize);
  }
  ctx.closePath();
  ctx.globalAlpha = item.style.background.opacity;
  ctx.fill();
  ctx.globalAlpha = 1;
  ctx.stroke();
}
function drawVertex(ctx, vertex, item, canvasSize) {
  if (isCurveVertex(vertex)) {
    drawCurveTo(ctx, vertex, item, canvasSize);
  } else {
    drawLineTo(ctx, vertex, item, canvasSize);
  }
}
function drawLineTo(ctx, vertex, item, canvasSize) {
  ctx.lineTo(...getNormalizedCoordinate(vertex.coordinate, item, canvasSize));
}
function drawCurveTo(ctx, vertex, item, canvasSize) {
  const [curveX, curveY] = getNormalizedCoordinate(vertex.curve, item, canvasSize);
  const [coordX, coordY] = getNormalizedCoordinate(vertex.coordinate, item, canvasSize);
  ctx.quadraticCurveTo(curveX, curveY, coordX, coordY);
}
function getNormalizedCoordinate(coordinate, item, canvasSize) {
  return [(item.position.x + coordinate.x * item.size.width) * canvasSize.width, (item.position.y + coordinate.y * item.size.height) * canvasSize.height];
}

export { drawLegacyCanvasShape };
//# sourceMappingURL=drawLegacyCanvasShape.js.map
